import { Header } from 'components/layout/header'
import { Layout } from 'components/layout/layout'
import { filterPropsType, pagedFilterType, pageProps, searchBarPropsType } from 'types'
import './_resource-search-page.scss'
import { SearchCard, SearchCardProps } from 'components/elements/search-card/search-card'
import { ListSearchPanelBlock } from 'components/blocks/list-search-panel-block/list-search-panel-block'
import { Resource } from 'components/blocks/resource/resource'

interface ResourceSearchPageProps extends pageProps {
  layout: React.ComponentProps<typeof Layout>
  header: React.ComponentProps<typeof Header>
  listSearchProps: {
    queryUrl: string
    searchBarProps: searchBarPropsType
    filterProps: filterPropsType
    defaultFilter: pagedFilterType
    noResultsText: string
    errorMessage: string
    resultsText: string
    closeButtonText: string
  }
  resources: React.ComponentProps<typeof Resource>[]
}

export const ResourceSearchPage = ({
  layout,
  header,
  listSearchProps,
  resources,
}: ResourceSearchPageProps) => {
  const userName = layout.userContext?.firstname
  const ingress =
    header.data.ingress.trim() != ''
      ? header.data.ingress
      : `Hei${
          userName ? `, ${userName}` : ''
        }. Vi har hjulpet deg med å tilgjengeliggjøre det viktigste innholdet.`

  const headerTitleAndIngress = {
    ...header,
    data: {
      ...header.data,
      ingress,
    },
  }

  return (
    <Layout
      {...layout}
      theme={layout.theme ?? { color: 'light-blue', type: 'gradient' }}
      className='resource-search-page'
    >
      {header && <Header {...headerTitleAndIngress} />}

      <div className='resource-search-page__body'>
        {listSearchProps && (
          <ListSearchPanelBlock
            queryUrl={listSearchProps.queryUrl}
            searchBarProps={{
              placeHolderLabel: listSearchProps.searchBarProps.placeHolderLabel,
              searchButtonLabel: listSearchProps.searchBarProps.searchButtonLabel,
            }}
            filterProps={{
              filterLabel: listSearchProps.filterProps.filterLabel,
              clearFilterText: listSearchProps.filterProps.clearFilterText,
              filterOptions: listSearchProps.filterProps.filterOptions,
            }}
            defaultFilter={{
              page: listSearchProps.defaultFilter.page,
              pageSize: listSearchProps.defaultFilter.pageSize,
            }}
            noResultsText={listSearchProps.noResultsText}
            errorMessage={listSearchProps.errorMessage}
            displayData={(results: SearchCardProps[]) => (
              <div className='search-page__results'>
                {results.map((result, i) => (
                  <SearchCard
                    key={i}
                    url={result.url}
                    title={result.title}
                    text={result.text}
                    image={result.image}
                    meta={result.meta}
                    theme={'blue'}
                  />
                ))}
              </div>
            )}
            closeButtonText={listSearchProps.closeButtonText}
            resultsText={listSearchProps.resultsText}
          />
        )}
        {resources && (
          <div className='resource-search-page__body__resource-list'>
            {resources && resources.map((resource) => <Resource {...resource} />)}
          </div>
        )}
      </div>
    </Layout>
  )
}
